import React from 'react';

const NotFound = () => {
    return (
        <div>
            <img className='w-full' src="https://i.ibb.co/n7RzNWy/404-2-1.png" alt="" />
        </div>
    );
};

export default NotFound;